import { Configuration, DefaultApi, ResponseContext } from '../generated-src';

const getBasePath = () => {
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }
  // Fallback for Playwright/Node.js environment
  return process.env.BASE_URL || 'http://localhost:3000'; 
};

const createAPI = () => {
  const defaultApi = new DefaultApi(new Configuration({ basePath: getBasePath() }));
  return defaultApi.withPostMiddleware(async (context: ResponseContext) => {
    // TODO: remove this after Szymon Tracz fixed OpenAPI spec
    // example problematic function: getBackUnitsItemsListHeaders
    const result = await context.response.text();
    try {
      const data = JSON.parse(result);
      return {
        status: context.response.status,
        text() {
          return data;
        },
        json() {
          return data;
        },
        value() {
          return data;
        },
      } as unknown as Response;
    } catch {
      return {
        status: context.response.status,
        text() {
          return result;
        },
        json() {
          return result;
        },
        value() {
          return result;
        },
      } as unknown as Response;
    }
  });
};

export const graphneAPI = createAPI();
